import React from "react";
import { Row, Col } from "reactstrap";

const Banner = ({ title, image, imageDesktop, subtitle, size, height }) => (
  <Row className="mx-0 section__ppal">
    <Col xs="12" className="p-0 container__section-banners">
      <Row className="mx-0" style={{ minHeight: '220px' }}>
        <Col xs="12" className="p-0">
          
          <picture>
            {/* Si existe imagen para desktop y la pantalla es de 768px o más */}
            {imageDesktop && (
              <source media="(min-width: 768px)" srcSet={imageDesktop} />
            )}
            {/* Imagen fallback / versión móvil */}
            <img
              src={image}
              loading="lazy"
              className={`w-100 image__section-banners image__banner--secondary ${height}`}
            />
          </picture>

          <div className="overlay-img-sections" />
        </Col>

        <Col
          xs="12"
          sm={size ? size : "6"}
          lg={size ? size : "4"}
          className="titles-float-profile-img d-flex align-items-center"
        >
          <div className="d-flex flex-column">
            <hr className="section-banner_info__line" />
            <h1 className="section-banner__title">{title}</h1>
            {subtitle && <p className="section-banner__text">{subtitle}</p>}
          </div>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default Banner;